/*
    - color: if r is larger than 1.0, the color channel is not used in shader
    - opacity: if opacity is larger than 1.0 than opacity is not used in shader
        - if it is smaller than EPSILON, the volume is not rendered
*/

class BaseMaterial {
    modelName;
    meshIdOffset;
    totalMesh;
    texture;

    constructor(modelId, modelName) {
        let self = this;
        this.modelId = modelId;
        this.modelName = modelName;
        const idBounds = getMinMaxVolumeId();
        this.meshIdOffset = idBounds.min;
        this.totalMesh = idBounds.max - idBounds.min + 1;

        this.texture = initializeTexture();
        initializeUniforms();

        function getMinMaxVolumeId() {
            const volumes = modelManager.getVolumesByModelId(modelId);
            const ids = volumes.map(entry => entry.meshID);
            const reducer = (acc, val) => ({min: Math.min(acc.min, val), max: Math.max(acc.max, val)});
            return ids.reduce(reducer, {min: Infinity, max: -Infinity});
        }

        function initializeTexture() {
            const dimension = getDimension(self.totalMesh);
            const data = new Float32Array(dimension.total * 4);
            for (let index = 0; index < self.totalMesh; index++) {
                data[4 * index] = data[4 * index + 3] = 2.0;
            }
            const texture = new THREE.DataTexture(data, dimension.width, dimension.height, THREE.RGBAFormat, THREE.FloatType);
            return texture;

            function getDimension(total) {
                const width = Math.ceil(Math.sqrt(total));
                const height = Math.ceil(total / width);
                return {width, height, total: width * height};
            }
        }

        function initializeUniforms() {
            let uniformArray = [
                {
                    name: 'meshIdOffset',
                    value: self.meshIdOffset
                },
                {
                    name: 'baseTexture',
                    value: self.texture
                },
                {
                    name: 'baseTextureWidth',
                    value: self.texture.image.width
                },
                {
                    name: 'baseTextureHeight',
                    value: self.texture.image.height
                }
            ];

            modelManager.updateModelMaterialUniforms(modelId, uniformArray);
            modelManager.setModelMaterialDefines(modelId, {
                USE_LOG_DEPTH_BUFFER: getLogDepthBufferValue(),
            });
        }
    }

    dispose() {
        this.texture.dispose();
    }

    setColor(branchId, color) {
        const data = this.texture.image.data;
        const index = this.getIndex(branchId);
        data[4 * index] = color[0];
        data[4 * index + 1] = color[1];
        data[4 * index + 2] = color[2];
        this.texture.needsUpdate = true;
    }

    setOpacity(branchId, opacity) {
        const data = this.texture.image.data;
        const index = this.getIndex(branchId);
        data[4 * index + 3] = opacity;
        this.texture.needsUpdate = true;
    }

    getIndex(branchId) {
        const volume = modelManager.getVolume(branchId);
        return volume.meshID - this.meshIdOffset;
    }
}

export default BaseMaterial;
